import { h, Fragment } from "preact";

export default function ProductOptionSwatch({
  optionValue,
  optionName,
  disabled,
  updateOptionValue,
  selected,
}) {
  return (
    <label className="product-options__swatch-wrapper">
      <input
        type="radio"
        name={optionName}
        value={optionValue.name}
        className="product-options__swatch-input"
        onChange={(e) => updateOptionValue(e.target.value)}
        checked={selected}
      />
      <div className="product-options__swatch">
        <div
          className={`
            product-options__swatch-inner
            ${optionValue.swatch ? "" : "product-options__swatch-inner--placeholder"}
            ${disabled ? "product-options__swatch-inner--disabled" : ""}
            `}
          style={{ "--swatch-color": optionValue.swatch?.color }}
        >
          {optionValue.swatch?.image && (
            <img
              className="product-options__swatch-image"
              src={window.getSizedImageUrl(
                optionValue.swatch.image.previewImage.url,
                "100x",
              )}
              alt=""
            />
          )}
          <span className="visually-hidden">{optionValue.name}</span>
        </div>
        {disabled && (
          <div className="product-options__swatch-disabled-slash"></div>
        )}
      </div>
    </label>
  );
}
